<template>
<card>
    <b-card-header class="border-0">
        <h3 class="mb-0" style="font-size: 18px; font-weight: bold; color: #2c3e50;">
            SENARAI PENJAWAT AWAM {{funcLabel}} <B>FASI BGE</B>
        </h3>
    </b-card-header>

    <!-- <CarianBaharu
      @carianProgram="searchProgram"
      @resetPaging="resetPaging"
    ></CarianBaharu> -->

    <el-table v-loading="loading" class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{
    background: '#f6f9fc',
    color: '#000',
    fontWeight: 'bold',
    fontSize: '16px'
  }" :cell-style="{
    fontWeight: 600,
    color: '#000',
    fontSize: '14px'
  }" :data="SenaraiPenjawatAwam" style="width: 100%">
        <el-table-column align="center" type="index" :index="indexMethod" width="70px" />
        <el-table-column label="NO KAD PENGENALAN" prop="NoKP" min-width="250px" />
        <el-table-column label="NAMA" prop="CONm" min-width="250px" />
        <el-table-column label="NO PERMOHONAN" prop="NoMohon" min-width="250px" />
        <el-table-column label="AGENSI" prop="Agensi" min-width="250px" />
        <el-table-column label="PEGAWAI PENGIRA" prop="PegPengira" min-width="250px" />

        <el-table-column label="Tindakan" min-width="250px" align="right" fixed="right">
            <template slot-scope="scope">
                <div class="flex space-x-2">
                    <base-button v-if="[2,3,4,5].includes(kiraan)" size="sm" icon type="primary" @click="showVal(scope.row)">
                        <span class="btn-inner--icon"></span>
                        <span class="btn-inner--text">Lihat</span>
                    </base-button>

                    <base-button v-if="kiraan === 2" size="sm" icon type="warning" @click="buatTindakan(scope.row)">
                        <span class="btn-inner--icon"></span>
                        <span class="btn-inner--text">Tindakan</span>
                    </base-button>

                    <base-button v-if="kiraan === 1" size="sm" icon type="success" @click="terimaPermohonan(scope.row)">
                        <span class="btn-inner--icon"><i class="fa fa-check"></i></span>
                        <span class="btn-inner--text">TERIMA</span>
                    </base-button>
                    <base-button v-if="kiraan === 4" size="sm" icon type="warning" @click="perluTindakan(scope.row)">
                        <span class="btn-inner--icon"><i class="fa fa-check"></i></span>
                        <span class="btn-inner--text">PERLU TINDAKAN</span>
                    </base-button>
                </div>
            </template>

        </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
        <el-pagination background layout="prev, pager, next" :total="ClientPaging.totalRow" :page-size="ClientPaging.totalRowPerPaging" @current-change="pageChanged">
        </el-pagination>
    </b-card-footer>
    <!--Form modal-->
    <modal :show.sync="modals.list" size="xl" body-classes="p-1">
        <template slot="header">
            <h3 class="mb-0">DETAIL PEGAWAI</h3>
        </template>
        <template>
            <MDTerima :listRow="listRow" :fromAction="fromAction" @batal="batal"></MDTerima>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>
</card>
</template>

<script>
import {
    Table,
    TableColumn,
    Pagination
} from "element-ui";
import GetsalaryService from "@/services/salaryService.js";
import Store from "@/store";
import BaseButton from "@/components/BaseButton.vue";
import MDTerima from "@/views/Skg/Fasi_BGE/MDTerima.vue";

export default {
    props: {
        kiraan: {
            type: Number,
            default: 0
        }
    },
    name: "DASHBOARD",
    components: {
        BaseButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Pagination.name]: Pagination,
        MDTerima

    },
    data() {
        return {
            SenaraiPenjawatAwam: [{
                    CONm: "SHUKRI AMIN",
                    NoKP: "2000101010101",
                    NoMohon: "M-001",
                    Agensi: "KPM",
                    PegPengira: "AKMAL",
                    Kategori: "KUMPULAN PELAKSANA",
                },
                {
                    CONm: "SAHDELI",
                    NoKP: "200301010101",
                    NoMohon: "K-002",
                    Agensi: "KPM",
                    PegPengira: "SOFIAN",
                    Kategori: "FASI BGE",
                }
            ],
            currentPage: 1,
            ClientPaging: {
                pagingType: 2,
                totalRow: 0,
                totalRowPerPaging: 0,
                totalPage: 0,
                memTableName: null,
                lastPage: 0,
            },
            loading: false,
            label: "",
            modals: {
                list: false,
            },
            listRow: {},
            fromAction: "", // "lihat" atau "terima"
        };
    },

    methods: {
        pageChanged(val) {
            this.currentPage = val;
            this.queryPageData(val);
        },
        showVal(scope) {
            console.log("scope", scope)
            this.modals.list = true;
            this.listRow = scope;
            this.fromAction = "lihat";
        },
        terimaPermohonan(scope) {
            this.modals.list = true;
            this.listRow = scope;
            this.fromAction = "terima"; 

        },
        batal() {
            this.modals.list = false;
            this.fromAction = "";
        },
        buatTindakan(scope) {
            console.log("scope", scope)
            this.$router.push({
                name: 'BUTIRAN MAKLUMAT PERIBADI',
                params: {
                    ICNo: '780812035875',
                    
                }
            })
        },
        perluTindakan(scope) {
            console.log("scope", scope)
            this.$router.push({
                name: 'KEMASKINI MAKLUMAT PEMOHON FASI',
                params: {
                    ICNo: '670131135590',
                    coid: '12',
                }
            })
        },


        queryPageData(currentPage) {
            this.loading = false;

            let search = {
                currentPage: currentPage,
            };

            // GetsalaryService.getSenaraiPenjawatAwamInfo(search)
            //   .then((resp) => {
            //    this.ClientPaging = resp.data;
            //       console.log("pagingInfo: ", resp.data);
            //   })
            //    .then(() => {
            //        GetsalaryService.getSenaraiPenjawatAwamdata(
            //           search
            //        ).then((resp) => {
            //            this.SenaraiPenjawatAwam = resp.data;
            //console.log("pagingData: ", SenaraiPenjawatAwam);
            //       });
            //    });
        },

        indexMethod(index) {
            return (
                index + 1 + (this.currentPage - 1) * this.ClientPaging.totalRowPerPaging
            );
        },
    },

    created() {
        this.queryPageData(1);

        console.log("kiraan", this.kiraan);

    },
    computed: {
        funcLabel() {
            if (this.kiraan === 1) {
                return "BARU";
            } else if (this.kiraan === 3) {
                return "DALAM PROSES";
            } else if (this.kiraan === 2) {
                return "DALAM TINDAKAN";
            } else if (this.kiraan === 5) {
                return "SELESAI / TUTUP";
            } else if (this.kiraan === 4) {
                return "PERLU TINDAKAN";
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped>
.table-responsive .el-table__header th {
    font-size: 16px;
    font-weight: bold;
    background-color: #f6f9fc;
    color: #000;
}

.table-responsive .el-table__body td {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.b-card-header h3 {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
    /* biru gelap profesional */
}
</style>
